import React, { Fragment } from 'react'
import moment from 'moment';
import ButtonGroup from './ButtonGroup';
import { MdArrowUpward } from "react-icons/md";

const detailGridClass = "grid min-w-[1020px] grid-cols-[120px_120px_140px_100px_120px_150px_120px_100px_125px]";

const DataRow = ({ data, hasDuplicataion, teamCount, fetchData }) => {
    return (
        <Fragment>
            {data.map((row, index) => {
                return (
                    <div key={index} className={`w-full text-xs font-semibold border-b border-customTitleColor text-customInk dark:border-customBorder dark:text-customWhite customFontRoboto ${hasDuplicataion ? 'bg-customLightYellow2/70 dark:bg-customLightYellow' : 'bg-white dark:bg-customSurface'}`}>
                        <div className={`${detailGridClass} items-center gap-3 px-4 py-3`}>
                            <div className="flex min-w-0 flex-col text-left">
                                <span>{moment(row.closetTime).format('yyy-MM-DD')}</span>
                                <span className='text-[10px]'>{moment(row.closetTime).format('hh:mm A')}</span>
                            </div>
                            <div className="min-w-0 text-left">
                                <p className="truncate">{row.userName}</p>
                            </div>
                            <div className="min-w-0 text-left">
                                <p className="truncate">{row.postingNo}</p>
                            </div>
                            <div className="text-right tabular-nums">
                                <div className='flex flex-col justify-end'>
                                    <p>{row.amount.toLocaleString('en-us')}</p>
                                    {
                                        row?.purchaseAmount ?
                                            <span className='flex items-center justify-end'><span className="text-green-500">+</span>{row?.purchaseAmount.toLocaleString('en-us')}</span>
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="text-right tabular-nums">
                                <div className='flex flex-col justify-end'>
                                    <p>{row.riskAmount.toLocaleString('en-us')}</p>
                                    {
                                        row?.purchaseRiskAmount ?
                                            <span className='flex items-center justify-end'><span className="text-green-500">+</span>{row?.purchaseRiskAmount.toLocaleString('en-us')}</span>
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="text-right tabular-nums">
                                <div className='flex flex-col justify-end'>
                                    <div className='flex items-center justify-end'>
                                        <p>{row.overedAmount.toLocaleString('en-us')}</p>
                                        <p className='text-[0.655rem] ml-1 text-customFontRed'>({row.limitAmount.toLocaleString('en-us')})</p>
                                    </div>
                                    {
                                        row?.purchaseRiskAmount ?
                                            <span className='flex items-center justify-end'><span className="text-green-500">+</span>{row?.purchaseRiskAmount.toLocaleString('en-us')}</span>
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="text-right tabular-nums">
                                <p className='text-customFontRed'>{((row?.purchaseRiskAmount || 0) - row.overedAmount).toLocaleString('en-us')}</p>
                            </div>
                            <div className="text-center">
                                 <div className='flex flex-col justify-end'>
                                    <p className={`text-center font-semibold ${(row.status === "Active") ? "text-customFontRed" : "text-customFontLightGreen"}`}>{row.status}</p>
                                    {
                                        row?.isPurchased ?
                                            <span className='flex items-center justify-end'><span className="text-green-500">+</span>Purchased</span>
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="flex justify-center select-none cursor-pointer">
                                <ButtonGroup data={row} teamCount={teamCount} fetchData={fetchData} />
                            </div>
                        </div>
                    </div>
                )
            }
            )}
            {hasDuplicataion ? <MultipleTotal data={data} /> : null}
        </Fragment>
    )
}

export default DataRow;

const MultipleTotal = ({ data }) => {
    const totalAmount = data.reduce((acc, item) => acc + item.amount, 0);
    const totalRiskAmount = data.reduce((acc, item) => acc + item.riskAmount, 0);
    const totalOveredAmount = data.reduce((acc, item) => acc + item.overedAmount, 0);

    return (
        <div className='w-full min-w-[1020px] text-xs font-bold border-b border-customTitleColor text-customInk dark:border-customBorder dark:text-customWhite customFontRoboto bg-customSummaryColor/40 dark:bg-customSurfaceMuted'>
            <div className={`${detailGridClass} items-center gap-3 px-4 py-3`}>
                <div />
                <div />
                <div className="text-left">
                    Total:
                </div>
                <div className="text-right tabular-nums">
                    {totalAmount.toLocaleString('en-us')} Ks
                </div>
                <div className="text-right tabular-nums">
                    {totalRiskAmount.toLocaleString('en-us')} Ks
                </div>
                <div className="text-right tabular-nums">
                    {totalOveredAmount.toLocaleString('en-us')} Ks
                </div>
                <div />
                <div />
            </div>
        </div>
    )
}

